
import Vue from "vue";
import { Prop, Watch, Component } from "vue-property-decorator";

@Component
export default class VisibleOptions extends Vue {
  localOption: string = '0';
  visibleChoices: Array<any> = [
    { value: "0", text: "All" },
    { value: "1", text: "CDS Only" },
    { value: "2", text: "CDS & Customer Only" },
    { value: "3", text: "CDS & Network Member Only" }
  ];

  @Prop({ default: null })
  visibleOption: string;

  created() {
    if(!this.localOption)
      this.localOption = "0";
  }

  get returnModel() {
    return {
      facilityViewable: this.localOption === "0" || this.localOption === "3",
      customerViewable: this.localOption === "0" || this.localOption === "2"
    };
  }

  @Watch("localOption")
  onLocalChange(val: any, oldVal: any) {
    if (val !== oldVal) {
      this.$emit("changeVisible", this.returnModel);
    }
  }

  @Watch("visibleOption", {immediate:true})
  onVisibleChange(val: any, oldVal: any) {
    if (val !== oldVal) {
      this.localOption = val;
    }
  }
}
